import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';
export class NetBoxContentBoxSlider {
    constructor() {
        this.instances = [];
        this.SELECTOR = '.netbox-content-box-swiper';
        this.init();
    }
    init() {
        const sliderElements = document.querySelectorAll(this.SELECTOR);
        if (sliderElements.length === 0)
            return;
        sliderElements.forEach((el) => {
            const swiperInstance = new Swiper(el, {
                modules: [Autoplay],
                slidesPerView: 1,
                spaceBetween: 15,
                loop: true,
                speed: 600,
                breakpoints: {
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 30
                    }
                },
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true
                },
            });
            this.instances.push(swiperInstance);
        });
    }
    destroy() {
        this.instances.forEach((instance) => {
            if (instance && typeof instance.destroy === 'function') {
                instance.destroy(true, true);
            }
        });
        this.instances = [];
    }
}
